// ─── BarRow ───────────────────────────────────────────────────────────────────

import {Box, Typography, useTheme} from '@mui/material';

interface BarRowProps {
    label: string;
    pct: number;
    value: string;
    barColor: string;
    valueColor: string;
}

const BarRow = ({label, pct, value, barColor, valueColor}: BarRowProps) => (
    <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
        <Typography
            variant='caption'
            color='text.disabled'
            sx={{width: 130, flexShrink: 0, textAlign: 'right'}}
        >
            {label}
        </Typography>
        <Box
            sx={{
                flex: 1,
                height: 26,
                bgcolor: useTheme().palette.grey[300],
                borderRadius: 1,
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                overflow: 'visible',
            }}
        >
            <Box
                sx={{
                    width: `${pct}%`,
                    height: '100%',
                    bgcolor: barColor,
                    borderRadius: 1,
                    transition: 'width 0.7s cubic-bezier(0.4,0,0.2,1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    position: 'relative',
                    minWidth: 0,
                }}
            >
                {pct > 18 ? (
                    <Typography
                        variant='caption'
                        sx={{pr: 1, fontWeight: 500, color: valueColor}}
                    >
                        {value}
                    </Typography>
                ) : (
                    <Typography
                        variant='caption'
                        sx={{
                            position: 'absolute',
                            left: 'calc(100% + 6px)',
                            fontWeight: 500,
                            color: 'text.secondary',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        {value}
                    </Typography>
                )}
            </Box>
        </Box>
    </Box>
);

export default BarRow;
